import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AudioProvider } from "./context/AudioContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ManageAudio from "./pages/ManageAudio";
import Playlists from "./pages/Playlists";
import Users from "./pages/Users";
import AuditLog from "./pages/AuditLog";
import Settings from "./pages/Settings";
import GamesControl from "./pages/GamesControl";
import ScreenSignIn from "./pages/ScreenSignIn";
import SelfScreen from "./pages/SelfScreen";
import TvSignage from "./pages/TvSignage";
import Memberships from "./pages/Memberships";
import MemberPortal from "./pages/MemberPortal";
import ChatAdmin from "./pages/ChatAdmin";
import PaymentResult from "./pages/PaymentResult";
import "./App.css";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-[#09090B] text-white font-display text-2xl">
        LOADING…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/admin" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/screen" element={<ScreenSignIn />} />
      <Route path="/selfscreen" element={<SelfScreen />} />
      <Route path="/tvs" element={<TvSignage />} />
      <Route path="/member" element={<MemberPortal />} />
      <Route path="/door" element={<MemberPortal door />} />
      <Route path="/" element={<MemberPortal />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
      <Route path="/memberships" element={<Protected><Memberships /></Protected>} />
      <Route path="/messages" element={<Protected><ChatAdmin /></Protected>} />
      <Route path="/admin" element={<Protected><Dashboard /></Protected>} />
      <Route path="/manage-audio" element={<Protected adminOnly><ManageAudio /></Protected>} />
      <Route path="/playlists" element={<Protected adminOnly><Playlists /></Protected>} />
      <Route path="/users" element={<Protected adminOnly><Users /></Protected>} />
      <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
      <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
      <Route path="/games" element={<Protected><GamesControl /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AudioProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
        </AudioProvider>
      </AuthProvider>
    </div>
  );
}
